const consoleSubstitution = console;

const logger = {
  error: consoleSubstitution.error,
  warn: consoleSubstitution.warn,
  info: consoleSubstitution.info,
};

export default logger;
